const Progress = ({ progress }) => {

    const displayIcon = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const icons = {
            pdf: 'fa-file-pdf',
            doc: 'fa-file-word',
            docx: 'fa-file-word',
            xls: 'fa-file-excel',
            xlsx: 'fa-file-excel',
            ppt: 'fa-file-powerpoint',
            pptx: 'fa-file-powerpoint',
            zip: 'fa-file-archive',
            rar: 'fa-file-archive',
            jpg: 'fa-file-image',
            jpeg: 'fa-file-image',
            png: 'fa-file-image',
            gif: 'fa-file-image',
            txt: 'fa-file-alt',
            csv: 'fa-file-csv',
            mp3: 'fa-file-audio',
            mp4: 'fa-file-video',
            mov: 'fa-file-video',
            avi: 'fa-file-video',
            default: 'fa-file'
        };

        return icons[extension] ? icons[extension] : icons['default'];
    }

    return (
        <div className="card p-3 mt-1">
            <div className="d-flex align-items-center">
                <i className={`fa ${displayIcon(progress.file_name)} fa-2x me-3 text-info`} aria-hidden="true"></i>
                <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center" style={{ maxWidth: '70%' }}>
                            <span className="text-truncate" title={progress.file_name} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '250px' }}>
                                {progress.file_name}
                            </span>
                            <span className="ms-1 text-muted"> - {(progress.percentage === 100) ? 'Voltooid' : 'Uploaden...'}</span>
                        </div>
                        <span className="text-black">{progress.percentage}%</span>
                    </div>

                    <div className="progress mt-2" style={{height: '6px'}}>
                        <div
                            className={`progress-bar ${progress.percentage === 100 ? 'bg-success' : 'bg-primary progress-bar-striped progress-bar-animated'}`}
                            role="progressbar"
                            style={{width: progress.percentage + '%'}}
                            aria-valuenow={progress.percentage}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        ></div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Progress;
